"use strict";
/**
 * Created by rouven on 17.03.17.
 */
/**
 * @module
 */
/**
 * @author rouven
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var redux_1 = require("redux");
var types = __importStar(require("../actions/actionTypes"));
/**
 * The data reducer is the reducer that handles all data and pagination actions (except LOAD_DATA_FAILURE,which gets handled by the errorReducer).
 * It sets or unsets the data storing part in the store.  The name of the action determines that part in the store
 * @public
 * @param reducers {function(object, object)} additional reducers to be called after this
 * @param {array | object} state The current state
 * @param {object} action The dispatched action
 * @returns {object} the next state
 */
var dataReducer = function (reducers) {
    if (reducers === void 0) { reducers = null; }
    var combinedReducers = reducers ? (0, redux_1.combineReducers)(reducers) : null;
    return function (state, action) {
        if (state === void 0) { state = {}; }
        var nextState = Object.assign({}, state);
        switch (action.type) {
            case types.LOAD_DATA_SUCCESS:
                nextState[action.name] = action.data;
                break;
            case types.LOAD_DATA_FAILURE:
                nextState[action.name] = [];
                break;
            case types.CLEAR_DATA:
                delete nextState[action.name];
                break;
            case types.SET_PAGINATION:
                if (!nextState.pagination) {
                    nextState.pagination = {};
                }
                nextState.pagination[action.name] = action.data;
                break;
            case types.CLEAR_PAGINATION:
                if (!nextState.pagination) {
                    nextState.pagination = {};
                }
                nextState.pagination[action.name] = {};
                break;
            default:
                nextState = state;
        }
        if (combinedReducers) {
            var subState = Object.keys(reducers).reduce(function (acc, val) {
                acc[val] = state[val];
                return acc;
            }, {});
            return Object.assign({}, nextState, combinedReducers(subState, action));
        }
        return nextState;
    };
};
exports["default"] = dataReducer;
